import { Heading } from '@app/app/_components/Heading/Heading';
import { Message } from '@app/app/_components/Message/Message';
import { BeneficiaryData } from '@app/domain/model/policy/BeneficiaryData';
import { useTranslations } from 'next-intl';
import { AddBeneficiaryButton } from './AddBeneficiaryButton';
import { BeneficiaryCard } from './BeneficiaryCard';

interface Props {
    existingBeneficiaries: BeneficiaryData[];
    newBeneficiaries: BeneficiaryData[];
    isCombinedShareFull: boolean;
    canAddMoreBeneficiaries: boolean;
    handleAddBeneficiary: () => void;
    removeBeneficiary: (beneficiaryId: string) => void;
    handleEditBeneficiary: (beneficiaryId: string) => void;
}

export function BeneficiaryListView({
    existingBeneficiaries,
    newBeneficiaries,
    isCombinedShareFull,
    canAddMoreBeneficiaries,
    handleAddBeneficiary,
    removeBeneficiary,
    handleEditBeneficiary,
}: Props) {
    const t = useTranslations();

    const hasAnyBeneficiaries = existingBeneficiaries.length > 0 || newBeneficiaries.length > 0;

    return (
        <>
            {!hasAnyBeneficiaries && <Message variant="info">{t('lifeInsurance.noBeneficiariesSet')}</Message>}

            <div className="flex flex-col gap-4">
                {existingBeneficiaries.length > 0 && (
                    <>
                        <Heading level="h4" className="text-neutral-600">
                            {t('lifeInsurance.existingBeneficiaries')}
                        </Heading>
                        {existingBeneficiaries.map((beneficiary: BeneficiaryData) => (
                            <BeneficiaryCard
                                key={`existing-${beneficiary.id}`}
                                beneficiary={beneficiary}
                                isExisting={true}
                                onDelete={removeBeneficiary}
                            />
                        ))}
                    </>
                )}

                {newBeneficiaries.length > 0 && (
                    <>
                        {existingBeneficiaries.length > 0 && (
                            <Heading level="h4" className="mt-6 text-neutral-600">
                                {t('lifeInsurance.newBeneficiaries')}
                            </Heading>
                        )}
                        {newBeneficiaries.map((beneficiary: BeneficiaryData) => (
                            <BeneficiaryCard
                                key={`new-${beneficiary.id}`}
                                beneficiary={beneficiary}
                                isExisting={false}
                                onEdit={handleEditBeneficiary}
                                onDelete={removeBeneficiary}
                            />
                        ))}
                    </>
                )}

                {isCombinedShareFull && <Message variant="info">{t('lifeInsurance.totalShareReached')}</Message>}

                {canAddMoreBeneficiaries && <AddBeneficiaryButton onAddBeneficiary={handleAddBeneficiary} />}
            </div>
        </>
    );
}
